import { updateOrderQtyorProducts } from "@DSG/Common/Utilities/CoveoUtilities";
import { CoveoProductContext, CoveoProductContextModel } from "@DSG/Components/Coveo/CoveoContext/CoveoProductContext";
import CoveoApplicationState from "@DSG/Store/Data/CoveoApplicationState/CoveoApplicationState";
import { CoveoProductInfo, CoveoProductModel, mapCoveoProductInfo } from "@DSG/Type/CoveoModels";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    coveoProduct: CoveoProductModel;
    idx?: number;
}

const mapStateToProps = (state: CoveoApplicationState, ownProps: OwnProps) => ({
    coveoProductInfo: mapCoveoProductInfo(ownProps.coveoProduct,state.DSGGlobalData.UpdatedProductQtyInfoList),
});

const mapDispatchToProps = {
    // changeUnitOfMeasure,
    // changeQtyOrdered,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

const CoveoProductListProductContext: FC<Props> = ({
    coveoProduct,
    coveoProductInfo,
    children,

    // changeUnitOfMeasure,
    // changeQtyOrdered,
    idx,
}) => {

    if (!coveoProductInfo) {
        return null;
    }

    const coveoProductContext: CoveoProductContextModel = {
        coveoProduct,
        coveoProductInfo,
        idx,
        onQtyOrderedChanged: qtyOrdered => updateOrderQtyorProducts(coveoProductInfo, coveoProduct.productId, qtyOrdered ),
        // onUnitOfMeasureChanged: unitOfMeasure => changeUnitOfMeasure({ productId: product.id, unitOfMeasure }),
    };

    // eslint-disable-next-line react/react-in-jsx-scope
    return <CoveoProductContext.Provider value={coveoProductContext}>{children}</CoveoProductContext.Provider>;
};

export default connect(mapStateToProps, mapDispatchToProps)(CoveoProductListProductContext);